import React, { useEffect, useMemo } from 'react'
import Select, { components } from 'react-select'
import Checkbox from '@material-ui/core/Checkbox'
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import { makeStyles } from '@material-ui/core/styles';

const customStyles = {
  control: (styles, {selectProps}) => {
    return {
    ...styles,
    boxShadow: 'none',
    borderColor: selectProps.error ? '#FF0000' : '#C7C7C7'
  }},
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      minWidth: '140px',
      backgroundColor: isDisabled
        ? null
        : isSelected || isFocused
        ? "#F6F6F6"
        : null,
      color: isDisabled
        ? '#000'
        : "#4B4B4B",

      ':active': {
        ...styles[':active'],
        backgroundColor:
          !isDisabled && "#dbdbdb",
      },
    };
  },
  indicatorSeparator: (styles) => ({
    ...styles,
    display: 'block'
  }),
  placeholder: (styles, {selectProps}) => ({
    ...styles,
    color: selectProps.placeholderColor === 'color1' ? '#989898' : '#4B4B4B',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '19px',
  }),
}

const useClearIconStyles = makeStyles({
  root: {
    color: '#707070',
    marginRight: '0.3rem',
  },
});

const MultiSelect =
  ({
    options,
    selected,
    lockOption,
    isDisabled,
    onChange,
    onOptionsChange,
    placeholder,
    isClearable,
    onClearAll,
    renderSeparator,
    styles,
    error
  }) => {
    const opt = useMemo(() => {
      return options.map((option)=>option.value).join('.')
    }, [options])

    useEffect(() => {
      if (onOptionsChange) {
        onOptionsChange()
      }
    }, [opt])

    const handleOnAddItem = (itemId, checked) => {
      if (lockOption) {
        return
      }
      onChange(itemId, checked)
    }
    const formatOptionLabel = ({ value, label }) => {
      const checked = selected?.some(item => {
        return item === value
      })

      return (
        <div onClick={() => handleOnAddItem(value, !checked)} className="simulador-financiero-multi-select">
          {' '}
          <Checkbox
            checked={checked}
            color="primary"
          />{' '}
          <span>{label}</span>
        </div>
      )
    }
    const quantity = (selected || []).filter(option=>option).length;

    const ClearIndicator = (props) => {
      const classes = useClearIconStyles();

      const { innerProps: { ref, ...restInnerProps  } } = props

      // Redefinimos el uso de onMouseDown para darle comportamiento por fuera del componente
      restInnerProps.onMouseDown = (e) => {
        e.stopPropagation()
        onClearAll()
      }

      return (
        <div {...restInnerProps} ref={ref}>
           <ClearRoundedIcon fontSize="small" classes={{root: classes.root}}/>
        </div>
      );
    };

    const IndicatorSeparator = (props) => {
      return renderSeparator ? <components.IndicatorSeparator {...props}/> : <></>
    };


    return (
      <Select
        placeholder={quantity > 1? `${quantity} seleccionados` : placeholder}
        placeholderColor={placeholder ? "color1" : "color2"}
        closeMenuOnSelect={false}
        selected={selected}
        value={lockOption ? lockOption : selected}
        isDisabled={isDisabled}
        controlShouldRenderValue={false}
        isClearable={isClearable}
        onClearAll={onClearAll}
        components = {{ ClearIndicator, IndicatorSeparator }}
        formatOptionLabel={formatOptionLabel}
        options={options}
        error={error}
        renderSeparator={renderSeparator}
        styles={styles || customStyles}
        theme={theme => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: '#4c1b9b',
          },
        })}
      />
    )
  }

export default MultiSelect
